<template>
  <v-main>
    <v-container fluid>
      <v-row justify="start" dense>
        <v-col cols="12">
          <v-card :class="reportClasses">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-2">
                  Мероприятия
                </h3>
              </div>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-card ref="form">
            <div class="text-center">
              <v-dialog
                v-model="dialogLoading"
                persistent
                width="300">
                <v-card
                  color="primary"
                  dark>
                  <v-card-text>
                    {{ dialogText }}
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0" />
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <!--<div class="d-flex flex-column mb-6">-->
            <!--<v-flex xs5>-->
            <!--<v-layout align-center justify-center wrap>-->
            <!--<v-layout row wrap>-->
            <BaseDatePicker ref="date"
                            :rules="[() => !!date || 'Поле обязательно']"
                            :error-messages="errorMessages"
                            :value="date"
                            :disabled="dialogLoading"
                            @dateUpdated="dateUpdated"
                            label="Дата"
                            style="padding-right: 20px;"
                            required />
            <v-text-field ref="name"
                          v-model="name"
                          :rules="[() => !!name || 'Поле обязательно']"
                          :error-messages="errorMessages"
                          :disabled="dialogLoading"
                          style="margin-left: 20px; margin-top: 15px;  padding-right: 20px;"
                          label="Название мероприятия"
                          required />

            <v-select ref="selectedAudience"
                      v-model="selectedAudience"
                      :items="audienceItems"
                      :multiple="false"
                      :rules="[() => !!selectedAudience || 'Поле обязательно']"
                      :error-messages="errorMessages"
                      style="margin-left: 20px; margin-top: 15px;  padding-right: 20px;"
                      label="Для кого проводилось мероприятие"
                      required />

            <v-text-field ref="location"
                          v-model.trim="location"
                          :rules="[() => !!location || 'Поле обязательно']"
                          :error-messages="errorMessages"
                          :disabled="dialogLoading"
                          style="margin-left: 20px; margin-top: 15px;  padding-right: 20px;"
                          label="Место проведения мероприятия"
                          required />
            <v-text-field ref="speaker"
                          v-model.trim="speaker"
                          :rules="[() => !!speaker || 'Поле обязательно']"
                          :error-messages="errorMessages"
                          :disabled="dialogLoading"
                          style="margin-left: 20px; margin-top: 15px;  padding-right: 20px;"
                          label="Кто проводил мероприятие"
                          required />
            <v-text-field ref="attended_num"
                          v-model="attended_num"
                          :rules="numericRules"
                          :error-messages="errorMessages"
                          :disabled="dialogLoading"
                          style="margin-left: 20px; margin-top: 15px;  padding-right: 20px;"
                          label="Количество участников мероприятия (исключая ведущих)"
                          required />
            <v-text-field ref="attended_new"
                          v-model="attended_new"
                          :rules="numericRules"
                          :error-messages="errorMessages"
                          :disabled="dialogLoading"
                          style="margin-left: 20px; margin-top: 15px;  padding-right: 20px;"
                          label="Количество впервые присутствующих на мероприятие"
                          required />
            <v-textarea ref="description"
                        v-model="description"
                        :rules="[() => !!description || 'Поле обязательно']"
                        :error-messages="errorMessages"
                        :disabled="dialogLoading"
                        style="margin-left: 20px; margin-top: 15px;  padding-right: 20px;"
                        label="Описание мероприятия (можно скопировать из рассылки)"
                        required />
            <!--</v-layout>-->
            <!--</div>-->

            <v-card />

            <!--            <v-snackbar-->
            <!--              v-model="alert"-->
            <!--              top-->
            <!--              :color="alertColor"-->
            <!--              :timeout="5000">-->
            <!--              {{ notificationText }}-->
            <!--            </v-snackbar>-->


            <v-col cols="12">
              <v-row align="center" justify="center">
                <v-btn :disabled="formDisabled"
                       @click="checkDuplicates"
                       color="primary"
                       class="mb-2">
                  Сохранить
                </v-btn>
              </v-row>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
      <CommonModals :dialog-report-duplicate.sync="dialogReportDuplicate"
                    :dialog-error-submit.sync="dialogErrorSubmit"
                    :dialog-empty-report.sync="dialogEmptyReport"
                    :dialog-submit.sync="dialogSubmit"
                    :error="error"
                    @checkDuplicates="checkDuplicates"
                    @clearReports="clearReport"
                    @addDuplicate="addDuplicate"
                    @toReports="toReports" />
    </v-container>
  </v-main>
</template>

<script>
import BaseDatePicker from '../../base/BaseDatePicker'
// import BaseDialog from '../../base/BaseDialog'
import axios from 'axios'
import {authHeader} from '../../../_helpers/auth-header'
import ReportsMixin from './ReportsMixinOld'
import CommonModals from './CommonModals'

export default {
  name: "ReportSeminars",
  components: {BaseDatePicker,CommonModals},
  mixins:[ReportsMixin],
  props: {
    reportId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {

      name: '',
      audienceItems: ['Для сотрудников и волонтеров ФАР', 'Для участников', 'Для сотрудников и участников',
        'Внешнее мероприятие'],
      selectedAudience: '',
      location: '',
      speaker: '',
      attended_num: '',
      attended_new: '',
      description: '',
      dialogText: 'Загружаются данные отчета',
      descLetter: '',
      date: new Date().toISOString().substr(0, 10),
      dateRules: [
        v => !!v || 'Поле обязательно',
        v => this.isValidDate(v) || 'Неверная дата'
      ],
      numericRules: [
        v => !!v || 'Поле обязательно',
        v => !isNaN(v) || 'Допустимы только численные значения'
      ]
    }
  },
  computed: {
    form () {
      return {
        selectedAudience: this.selectedAudience,
        location: this.location,
        speaker: this.speaker,
        attended_num: this.attended_num,
        attended_new: this.attended_new,
        description: this.description,
        date: this.date,
        name: this.name,
      }
    },
    // reportsUrl ()  {
    //   return this.$store.state.tableData.backend + '/api/reports/' + this.reportType
    // },
    // url () {
    //   return this.reportId ?  this.reportsUrl + '/' + this.reportId : this.reportsUrl
    // },
    // reportType () {
    //   return this.$route.meta.reportType
    // },
    // reportClasses () {
    //   let header = this.isPageDisabled ? 'read-only-header' : this.reportType
    //   return [header]
    // },
    // formDisabled () {
    //   return Object.entries(this.form).filter(p => {
    //     return p
    //   }).some(x => (x[1] === null || x[1] ===
    //     '' || x[1].length === 0))
    // },
  }
  ,
  watch: {
    reportId (newValue) {
      newValue === null ? this.clearReport() : newValue
    },
    form (newValue) {
      sessionStorage.setItem("seminars", JSON.stringify(newValue))
    }
  },
  mounted () {
    if (this.reportId !== null) {
      this.dialogText = 'Загружаются данные отчета'
      let report
      let vm = this
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      }
      // let form = vm.form
      // form['descLetter']=vm.descLetter
      axios({
        method: 'get',
        url: this.reportsUrl + '/' + this.reportId,
        headers: requestOptions['headers']
      }).then((response) => {
        report = response.data
        vm.dialogLoading = false
        vm.selectedAudience = report.audience
        vm.location = report.location
        vm.speaker = report.speaker
        vm.attended_num = report.attended_num
        vm.attended_new = report.attended_new
        vm.description = report.description
        vm.date = report.date
        vm.name = report.name

      }).catch((error) => {
        vm.loading = false
        throw new Error(`You can't load the data`)
      })
    }
    else {
      this.customerHeaders = this.customerHeadersExtended
      let rep = JSON.parse(sessionStorage.getItem("seminars"))
       if  (rep)
          {
            this.date = rep.date
            this.location = rep.location
            this.speaker = rep.speaker
            this.attended_num = rep.attended_num
            this.attended_new = rep.attended_new
            this.description = rep.description
            this.name = rep.name
            this.selectedAudience = rep.selectedAudience

          }
    }

  },
  methods: {

    dateUpdated (newVal) {
      this.date = newVal
    },
    clearReport () {
      this.dialogSubmit = false
      this.date = new Date().toISOString().substr(0, 10)
      this.hours = 0
      sessionStorage.setItem("seminars", null)
      this.selectedAudience=''
      this.location=''
      this.speaker=''
      this.attended_num=''
      this.attended_new=  ''
      this.description = ''
      this.name = ''

    },
    // submitReport () {
    //   const requestOptions = {
    //       method: 'GET',
    //       headers: authHeader()
    //     }
    //   this.formHasErrors = false
    //   let vm = this
    //   Object.keys(vm.form).forEach(f => {
    //     if (f!=='descLetter') {
    //     if (!vm.form[f]) {
    //       vm.formHasErrors = true
    //       vm.$refs[f].validate(true)
    //     }
    //     else {
    //       if (f === 'date') vm.$refs[f].$children[0].$children[0].validate(true)
    //       else {
    //         vm.$refs[f].validate(true)
    //       }
    //     }
    //   } })
    //
    //   if (!this.formHasErrors) {
    //     if (!this.reportId) {
    //       let vm = this
    //       async function asyncFunc (vm) {
    //         // fetch data from a url endpoint
    //         try {
    //           const response = await axios({
    //             method: 'post',
    //             url: vm.reportsUrl +'/check_report',
    //             headers: requestOptions['headers'],
    //             data: vm.submitForm
    //           })
    //           const data = await response
    //           if (data.status === 200) vm.submitRequest()
    //           return data.status
    //         } catch (error) {
    //           //console.log(error)
    //           vm.dialogReportDuplicate = error.message.indexOf('409')>-1
    //           vm.loading = false
    //         }
    //       }
    //
    //       asyncFunc(vm)
    //
    //     }
    //      else vm.submitRequest()
    //   }
    // }
  },
  beforeRouteLeave (to, from, next) {
    sessionStorage.setItem("seminars", null)
    this.selectedUsers = []
    this.date = new Date().toISOString().substr(0, 10)
    next()

  }
}
</script>

<style lang="scss" scoped>
.loading-dialog {
  background-color: #303030
}
</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportSeminars.vue